import { connect } from 'react-redux'
import { fetchEmployments, fetchEmploymentsSuccess, fetchEmploymentsFailure } from '../actions/employments';
import EmploymentsList from '../components/Employments';

const mapStateToProps = (state) => {
    return {
        employmentsList: state.employments.employmentsList
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchEmployments: () => {
            dispatch(fetchEmployments()).then((response) => {
                !response.error ? dispatch(fetchEmploymentsSuccess(response.payload.data)) : dispatch(fetchEmploymentsFailure(response.payload.data));
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmploymentsList);



/** WEBPACK FOOTER **
 ** ./src/containers/EmploymentsContainer.js
 **/